import React, { useRef } from "react";
import "./SendMail.css";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SendMail() {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_user_id,
        process.env.REACT_APP_templete_key,
        form.current,
        process.env.REACT_APP_public_key
      )
      .then(
        (result) => {
          console.log(result.text);
          form.current.reset();
          showSuccessToast();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const showSuccessToast = () => {
    toast.success("Email sent successfully!", {
      position: "top-right",
      autoClose: 3000, // Auto close the toast after 3 seconds
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  return (
    <div className="mail-box">
      {/* <form>
        <label for="text">Name</label>
        <input type="text"></input>
        <label for="text">Email</label>
        <input type="text"></input>
        <label for="text">Subject</label>
        <input type="text"></input>
        <label for="multilineInput">Body</label>
        <textarea
          id="multilineInput"
          name="multilineInput"
          rows="4"
          cols="50"
        ></textarea>
      </form> */}
      <form id="myFrom" ref={form} onSubmit={sendEmail}>
        <label>Name</label>
        <input type="text" name="user_name" />
        <label>Email</label>
        <input type="email" name="user_email" />
        <label>Message</label>
        <textarea name="message" id="multilineInput" rows="4" cols="50" />
        <input
          style={{ backgroundColor: "var(--dark-blue)", color: "white" }}
          type="submit"
          value="Send🚀"
        />
      </form>
      <ToastContainer />
    </div>
  );
}
